export { default } from "./InfoPlayerView";
